import {
  Sparkle,
  MapTrifold,
  Path,
  House,
  GraduationCap,
  NotePencil,
  Trophy,
  ChartLineUp,
  UserCircle,
  SquaresFour,
  Headphones,
  ChatCircleDots,
  UsersThree,
  ClockCounterClockwise,
} from "@phosphor-icons/react";

export const ARCHITECTURE_NAV = [
  { id: "overview", label: "Overview", icon: Sparkle },
  { id: "map", label: "Navigation Map", icon: MapTrifold },
  { id: "journeys", label: "User Journeys", icon: Path },
  { id: "home", label: "Home", icon: House },
  { id: "learn", label: "Learn", icon: GraduationCap },
  { id: "homework", label: "Homework", icon: NotePencil },
  { id: "rewards", label: "Rewards", icon: Trophy },
  { id: "progress", label: "Progress", icon: ChartLineUp },
  { id: "profile", label: "Profile", icon: UserCircle },
  { id: "modes", label: "Learning Modes", icon: SquaresFour },
  { id: "sensory", label: "Multi-Sensory", icon: Headphones },
  { id: "feedback", label: "Feedback", icon: ChatCircleDots },
  { id: "age", label: "Age Adaptation", icon: UsersThree },
  { id: "timeline", label: "Timeline", icon: ClockCounterClockwise },
];
